import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { State } from '../../util/interactiveState.js';
import { selectToken } from '../../util/tokenSelector.js';
import { LinkStyled } from '../Link/Link.styled.js';

var cardInteractiveState = function cardInteractiveState(theme) {
  if (!theme) return null;
  var shadowL = selectToken(theme.shadow, 'bottom-l');
  var shadowM = selectToken(theme.shadow, 'bottom-m');

  // interactive focus indicator
  var textPrimaryInteractiveToken = selectToken(theme.text, 'product.primary');
  if (!textPrimaryInteractiveToken) return {};
  var textNeutral4Token = selectToken(theme.text, 'base.inverted');
  if (!textNeutral4Token) return {};
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    WebkitTapHighlightColor: 'transparent',
    transition: 'box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out'
  }, "&".concat(State.Hover), {
    boxShadow: shadowL
  }), "&".concat(State.FocusedVisible), {
    boxShadow: "0 0 0 2px ".concat(textNeutral4Token, ", 0 0 0 4px ").concat(textPrimaryInteractiveToken)
  }), "&".concat(State.Pressed), {
    boxShadow: shadowM
  }), "".concat(LinkStyled).concat(State.FocusedVisible, " &"), {
    boxShadow: "0 0 0 2px ".concat(textNeutral4Token, ", 0 0 0 4px ").concat(textPrimaryInteractiveToken)
  }), "button".concat(State.FocusedVisible, " > &"), {
    boxShadow: "0 0 0 2px ".concat(textNeutral4Token, ", 0 0 0 4px ").concat(textPrimaryInteractiveToken)
  });
};

export { cardInteractiveState as default };
//# sourceMappingURL=cardInteractiveState.js.map
